import React, { useEffect, useState } from "react";

import FundraisingIcon from "../../images/icons/fundraising-icon.inline.svg";

const FundraisingSummary = ({
  programCode,
  containerClass = "flex icon-wrapper justify-items-center items-center py-2 sm:py-0",
  iconClass = "w-4 h-full fill-black-lighter dark:fill-white",
  descClass = "text-black-lighter dark:text-gray-generic pl-2"
}) => {
  const [fundraisersList, setFundraisersList] = useState([]);
  const [fundraisersCount, setFundraisersCount] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals

    const controller = new AbortController();
    const signal = controller.signal;

    let apiUrl = ["/api/fundraiser/list"].join("");

    const getFundraisers = async () => {
      const res = await fetch(`${apiUrl}?limit=100`, {
        signal: signal
      });

      const fundraisers = await res.json();
      // console.debug("Fundraisers => ", fundraisers);
      const { list } = fundraisers ?? {};

      setFundraisersList(list);
      const programFundraisersList =
        fundraisersList?.filter(
          (fundraiser) => fundraiser?.programs?.program_code === programCode
        ) ?? [];

      setFundraisersCount(programFundraisersList.length);
    };

    getFundraisers().catch(console.error);

    return () => {
      controller.abort();
    };
  }, [programCode]);

  if (fundraisersCount < 1) return <></>;
  // console.debug("fundraisersCount => ", fundraisersCount);
  return (
    <div className={containerClass}>
      <FundraisingIcon className={iconClass} />
      <div
        className={descClass}
        dangerouslySetInnerHTML={{
          __html: `${fundraisersCount} ${fundraisersCount > 1 ? "participants" : "participant"} fundraising`
        }}
      />
    </div>
  );
};

export default FundraisingSummary;
